var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderIcon = function SvgFolderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.17.9-Setup-/-Company-/-Create-new-project-/-Step-2---view-timeslots--time-slots",
    transform: "translate(-356.000000, -189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(320.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(16.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375,7.93749998 C21.375,6.72937708 20.3956229,5.74999997 19.1875,5.74999997 L10.5980469,5.74999997 C10.4130846,5.75059244 10.2321181,5.6962073 10.078125,5.59374997 L8.99218748,4.86757809 C8.63258897,4.62711458 8.20954191,4.49915338 7.7769531,4.49999579 L4.81249996,4.49999579 C3.60437707,4.49999579 2.62499995,5.47937708 2.62499995,6.68749997 L2.62499995,8.56249998 C2.62499995,8.73508897 2.76491097,8.87499998 2.93749995,8.87499998 L21.0625,8.87499998 C21.235089,8.87499998 21.375,8.73508897 21.375,8.56249998 L21.375,7.93749998 Z M2.62499995,17.3125 C2.62499995,18.5206229 3.60437707,19.5 4.81249996,19.5 L19.1875,19.5 C20.3956229,19.5 21.375,18.5206229 21.375,17.3125 L21.375,10.4375 C21.375,10.264911 21.235089,10.125 21.0625,10.125 L2.93749995,10.125 C2.76491097,10.125 2.62499995,10.264911 2.62499995,10.4375 L2.62499995,17.3125 Z",
    id: "Combined-Shape",
    fill: "#666666",
    mask: "url(#mask-2)"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-icon.d6cff4ed.svg";
export { ForwardRef as ReactComponent };